import React from 'react';

import Tooltip from '../Tooltip';
import LocationInfo from '../LocationInfo';
import Disclaimer from '../Disclaimer';

export default ({ statusDetail }) => (
  <article className="has-border-grey nbn-infobox__article content-area-white clearfix">
    <div className="one_half nbn-infobox__column">
      <p className="nbn-infobox__column__text">nbn<sup className="text-xxx-small">TM</sup> is expected to commence construction in some parts of this suburb within 3 years.</p>
      <div className="nbn-def-list">
        <dl className="has-margin-bottom-xsmall clearfix">
          <dt>Ready for Service <span className="relative"><Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">The date NBN currently expects to complete in this rollout area. This is a forward-looking date and may be subject to change</p></Tooltip></span></dt>
          <dd>{ statusDetail.rfs_date }</dd>
        </dl>
        { statusDetail.disconnection_date
            ? (
            <dl className="has-margin-bottom-xsmall clearfix">
                <dt>Disconnection Date <span className="relative"><Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">Existing phone and internet services delivered over Telstra's copper network will be switched off from this date</p></Tooltip></span></dt>
        <dd>{ statusDetail.disconnection_date }</dd>
        </dl>
        )
        : null
        }
        <dl className="clearfix">
          <dt>Rollout Type <span className="relative"><Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">The NBN technology and rollout type of rollout used in this rollout area</p></Tooltip></span>
            <img src="https://dvh1deh6tagwk.cloudfront.net/finder-au/wp-uploads/2020/07/powered-by-nbn-lozenge.png" className="luna-image" alt="powered by nbn" /> 
          </dt>
          <dd>{ statusDetail.service_type_name }</dd>
        </dl>
      </div>
    </div>
    <div className="one_half nbn-infobox__column">
      <LocationInfo statusDetail={statusDetail} />
      { statusDetail.sa_id
          ? <a href={`https://www.finder.com.au/nbn-tracker/sa/${statusDetail.sa_id}`} className="btn-link nbn-btn-link">More Info</a>
      : null
      }
    </div>
    <Disclaimer />
  </article>
);
